import { FC } from "react";
import { Link } from "react-router-dom";
export interface LabelProps {
  className?: string;
  created: string;
  username: string;
  message: string;
}

const MessagesListItem: FC<LabelProps> = ({
  className = "",
  created,
  username,
  message,
}) => {
  return (
    <Link
      to={`/dash/messages/${username}`}
      className="flex flex-row items-center hover:bg-gray-100 rounded-xl p-2"
    >
      <div className="flex items-center justify-center h-8 w-8 bg-indigo-200 rounded-full">
        <img
          src={process.env.REACT_APP_API_URL + "/api/media/avatar/" + username}
          className="object-cover h-8 w-8 rounded-full"
          alt=""
        />
      </div>
      <div className="md:block hidden  ml-2 text-sm font-semibold text-start">
        <div className=" ">{username}</div>
        <span className="text-xs font-thin text-gray-500">{message}</span>
      </div>
    </Link>

    //   <div className="flex flex-row py-4 px-2 justify-center items-center border-b-2" >
    //   <div className="w-1/4">
    //     <img
    //       src={process.env.REACT_APP_API_URL+"/api/media/avatar/"+username}
    //       className="object-cover h-12 w-12 rounded-full"
    //       alt=""
    //     />
    //   </div>
    //   <div className="w-full">
    //     <div className="text-lg font-semibold">{username}</div>
    //     <span className="text-gray-500">{message}</span>
    //   </div>
    // </div>
  );
};

export default MessagesListItem;
